import { Link } from "react-router-dom";
import { MapPin, MessageCircle } from "lucide-react";

export function SchoolCard({ school }) {
  const count = school.review_count || 0;
  return (
    <Link
      to={`/scuola/${school.id}`}
      data-testid={`school-card-${school.id}`}
      className="block card-surface p-6 hover:border-[#C05C45] transition-colors group"
    >
      <div className="flex items-start justify-between gap-4">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <span className={`label-eyebrow ${school.type === "pubblica" ? "text-[#1A362D]" : "text-[#C05C45]"}`}>
              {school.type === "pubblica" ? "Pubblica" : "Paritaria/Privata"}
            </span>
          </div>
          <h3 className="font-display text-xl sm:text-2xl text-[#1A362D] leading-tight group-hover:text-[#C05C45] transition-colors">
            {school.name}
          </h3>
          <div className="flex items-start gap-1.5 mt-2 text-[#5C6B64] font-ui text-sm">
            <MapPin size={14} className="mt-0.5 flex-shrink-0" />
            <span>{school.address} — {school.postal_code} {school.city} ({school.province})</span>
          </div>
        </div>
        <div className="text-right shrink-0">
          {count > 0 ? (
            <span
              data-testid={`school-card-reviews-${school.id}`}
              className="inline-flex items-center gap-1.5 bg-[#DCE4DC] text-[#1A362D] rounded-full px-3 py-1 font-ui text-xs font-semibold"
            >
              <MessageCircle size={13} />
              {count} {count === 1 ? "recensione" : "recensioni"}
            </span>
          ) : (
            <span className="font-ui text-xs text-[#5C6B64] italic">Ancora nessuna recensione</span>
          )}
        </div>
      </div>
    </Link>
  );
}
